<template>
  <modal :value="value"
         max-width="500"
         contentClass="modal-visible"
         @input="emitInput">

    <div class="voucher-segment-client-generate-modal-body">
      <app-form class="voucher-segment-client-generate-modal-body-form"
                ref="voucherForm"
                @submit="generateVoucherClient">
        <h1 class="text-muted text-center">
          Gerar Vouchers
        </h1>

        <text-field class="marketing-automation-create-name"
                    v-model="form.quantity"
                    label="Quantidade de Vouchers"
                    name="Quantidade de Vouchers"
                    validate="required" />

        <text-field class="marketing-automation-create-name"
                    v-model="form.useLimit"
                    label="Quantidade de usos"
                    name="Quantidade de usos"
                    help="Caso não seja inserido um valor, a quantidade de usos será ilimitada" />

        <text-field class="marketing-automation-create-name"
                    v-model="form.comment"
                    label="Comentário"
                    name="Comentário"
                    validate="required" />

        <checkbox v-model="hasExpirationDate"
                  label="Adicionar data de expiração"
                  class="expiration-date-checkbox"
                  hideDetails/>

        <app-box-wrapper v-if="hasExpirationDate"
                        data-label="Data de Expiração"
                        data-icon="mdi-calendar-range">

            <app-date-picker v-model="form.expirationDate"
                            menu-width="auto"></app-date-picker>

        </app-box-wrapper>
      </app-form>
    </div>

    <template v-slot:footer>
      <app-button class="voucher-segment-client-generate-modal-body-form-action btn btn-primary"
                  :label="$t('message.generics.message.add')"
                  type="submit"
                  flat
                  primary
                  @click="forceSubmit">
      </app-button>
    </template>
  </modal>
</template>

<script>
import AppForm from "@components/form/Form.vue";
import TextField from "@components/form/TextField.vue";
import Modal from "@/components/generic/Modal";
import AppButton from "@/components/generic/button/Button";
import EventBus from "@packages/event-bus/index";
import AppBoxWrapper from "@components/BoxWrapper";
import AppDatePicker from "@components/DatePicker";
import Checkbox from "@components/Checkbox";

export default {
  components: {
    Modal,
    TextField,
    AppForm,
    AppButton,
    AppBoxWrapper,
    AppDatePicker,
    Checkbox
  },

  data() {
    return {
      infiniteId: +new Date(),
      form: {
        quantity: undefined,
        useLimit: undefined,
        comment: undefined,
        expirationDate: new Date().toISOString().substring(0, 10)
      },
      hasExpirationDate: false
    };
  },

  props: {
    value: {
      type: Boolean,
    },
    segment: {
      type: Object,
      required: true,
    },
  },

  watch: {
    value(val) {
      if(val) {
        this.resetValidation();
        this.resetData();
        this.hasExpirationDate = false;
      }
    },
    hasExpirationDate(val) {
      if(!val) {
       this.form.expirationDate = new Date().toISOString().substring(0, 10)
      }
    }
  },

  computed: {},

  methods: {
    forceSubmit() {
      this.$refs.voucherForm.submit();
    },
    emitInput(newVal) {
      this.$emit("input", newVal);
    },
    async generateVoucherClient() {
      try {
        await this.$api.core.voucher.client.generate({
          quantity: this.form.quantity,
          useLimit: this.form.useLimit,
          comment: this.form.comment,
          expirationDate: this.hasExpirationDate ? this.form.expirationDate : null,
          segmentId: this.segment.id,
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: "Vouchers criados com sucesso!",
        });

        this.$emit("created");

        this.emitInput(false);

        this.resetData()
      } catch (error) {
        console.log(error);
      }
    },
    resetData() {
      this.form = {
        quantity: undefined,
        useLimit: undefined,
        comment: undefined,
        expirationDate: new Date().toISOString().substring(0, 10)
      }
      this.hasExpirationDate = false
    },
    resetValidation() {
      this.$refs.voucherForm.reset();
    },

  },
};
</script>

<style lang="scss" scoped>
.voucher-segment-client-generate-modal-body {
  .voucher-segment-client-generate-modal-body-form {

    .dates {
      display: flex;
      gap: 30px
    }

    .expiration-date-checkbox {

      ::v-deep .v-input__slot {
        align-items: center;

      }

      ::v-deep .checkbox-label {

        p {
          margin-bottom: 0;
        }
      }

    }

    .voucher-segment-client-generate-modal-body-form-action {
      margin: 0 auto;
      margin-top: 40px;
    }
  }
}
</style>
